<div class="wash-packages-panel">
  <!-- Header -->
  <div class="panel-header">
    <h3 class="panel-title">Wash Packages Section</h3>
    <button class="close-btn" (click)="onClose()" aria-label="Close panel">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </button>
  </div>

  <!-- Tabs -->
  <div class="tabs-container">
    <div class="segment-control">
      <button 
        class="segment-btn"
        [class.active]="activeTab === 'content'"
        (click)="switchTab('content')">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
          <path d="M3 6h12M3 10h12M3 14h8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
        Content
      </button>
      <button 
        class="segment-btn"
        [class.active]="activeTab === 'layout'"
        (click)="switchTab('layout')">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
          <rect x="3" y="3" width="5" height="5" stroke="currentColor" stroke-width="1.5"/>
          <rect x="10" y="3" width="5" height="5" stroke="currentColor" stroke-width="1.5"/>
          <rect x="3" y="10" width="5" height="5" stroke="currentColor" stroke-width="1.5"/>
          <rect x="10" y="10" width="5" height="5" stroke="currentColor" stroke-width="1.5"/>
        </svg>
        Layout
      </button>
    </div>
  </div>

  <!-- Content Tab -->
  <div class="panel-content" *ngIf="activeTab === 'content'">
    
    <!-- Heading & Paragraph Section -->
    <div class="accordion-section" [class.expanded]="isSectionExpanded('heading')" (click)="toggleSection('heading')">
      <div class="accordion-header">
        <h4 class="section-title">Heading & Paragraph</h4>
        <button class="collapse-btn" [class.expanded]="isSectionExpanded('heading')" type="button">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M4 6L8 10L12 6" stroke="#15172E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" vector-effect="non-scaling-stroke"/>
          </svg>
        </button>
      </div>
      
      <div class="accordion-content" *ngIf="isSectionExpanded('heading')" (click)="$event.stopPropagation()">
        <div class="content-divider"></div>
        <!-- Heading Input -->
        <div class="form-group">
          <label class="form-label">Heading</label>
          <app-text-editor
            [value]="data.title || ''"
            [style]="data.titleStyle || {}"
            placeholder="Enter heading text..."
            (valueChange)="onTitleChange($event)"
            (styleChange)="onTitleStyleChange($event)">
          </app-text-editor>
        </div>

        <!-- Paragraph Input -->
        <div class="form-group">
          <label class="form-label">Paragraph</label>
          <textarea 
            class="paragraph-input"
            [value]="data.subtitle || ''"
            (input)="onSubtitleChange($any($event.target).value)"
            placeholder="Enter paragraph text...">
          </textarea>
        </div>
      </div>
    </div>

    <!-- Theme Section -->
    <div class="accordion-section" [class.expanded]="isSectionExpanded('theme')" (click)="toggleSection('theme')">
      <div class="accordion-header">
        <h4 class="section-title">Theme</h4>
        <button class="collapse-btn" [class.expanded]="isSectionExpanded('theme')" type="button">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M4 6L8 10L12 6" stroke="#15172E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" vector-effect="non-scaling-stroke"/>
          </svg>
        </button>
      </div>
      
      <div class="accordion-content" *ngIf="isSectionExpanded('theme')" (click)="$event.stopPropagation()">
        <div class="content-divider"></div>
        <div class="form-theme-selector">
          <label class="theme-label">Choose light or dark theme for the packages section</label>
          <div class="theme-options">
            <div 
              class="theme-option" 
              [class.selected]="selectedTheme === 'light'"
              (click)="selectTheme('light'); $event.stopPropagation()">
              <div class="theme-box light-theme">
                <svg *ngIf="selectedTheme === 'light'" class="check-icon" width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path d="M11.6667 3.5L5.25 9.91667L2.33333 7" stroke="#079271" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
            <div 
              class="theme-option" 
              [class.selected]="selectedTheme === 'dark'"
              (click)="selectTheme('dark'); $event.stopPropagation()">
              <div class="theme-box dark-theme">
                <svg *ngIf="selectedTheme === 'dark'" class="check-icon" width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path d="M11.6667 3.5L5.25 9.91667L2.33333 7" stroke="#079271" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Package Accordions -->
    <div *ngIf="loading" class="loading-state">
      <p>Loading packages...</p>
    </div>

    <div 
      class="accordion-section" 
      *ngFor="let pkg of packages; trackBy: trackById"
      [class.expanded]="isSectionExpanded(pkg.id)"
      (click)="toggleSection(pkg.id)">
      <div class="accordion-header">
        <h4 class="section-title">{{ pkg.package_name || 'Package' }}</h4>
        <button class="collapse-btn" [class.expanded]="isSectionExpanded(pkg.id)" type="button">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M4 6L8 10L12 6" stroke="#15172E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" vector-effect="non-scaling-stroke"/>
          </svg>
        </button>
      </div>
      
      <div class="accordion-content" *ngIf="isSectionExpanded(pkg.id)" (click)="$event.stopPropagation()">
        <div class="content-divider"></div>
        
        <div class="package-settings">
          <!-- Image Upload Section -->
          <div class="image-upload-section">
            <div class="image-preview-container">
              <div class="image-preview" [style.background-image]="'url(' + getPackageImage(pkg.id) + ')'">
                <div class="image-overlay" *ngIf="!hasPackageImage(pkg.id)">
                  <div class="upload-placeholder">
                    <img [src]="packageIconFallback" alt="Placeholder" class="placeholder-image">
                  </div>
                </div>
                <!-- Upload loading overlay -->
                <div class="image-overlay" *ngIf="uploadingImages[pkg.id]" style="background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center;">
                  <div style="color: white; text-align: center;">
                    <div style="margin-bottom: 8px;">Uploading...</div>
                    <div style="font-size: 12px;">Please wait</div>
                  </div>
                </div>
                <!-- Upload error message -->
                <div class="image-overlay" *ngIf="uploadErrors[pkg.id] && !uploadingImages[pkg.id]" style="background: rgba(220, 38, 38, 0.9); display: flex; align-items: center; justify-content: center;">
                  <div style="color: white; text-align: center; padding: 8px;">
                    <div style="font-size: 12px;">{{ uploadErrors[pkg.id] }}</div>
                  </div>
                </div>
              </div>
              <button class="replace-btn" (click)="onReplaceImage(pkg.id); $event.stopPropagation()" [disabled]="uploadingImages[pkg.id]">
                {{ uploadingImages[pkg.id] ? 'Uploading...' : 'Replace' }}
              </button>
            </div>
            
            <div class="file-info">
              <div class="file-info-item">
                <span class="file-info-text">Accepted formats - .png, .jpg, .jpeg, .mp4</span>
                <div class="divider"></div>
                <span class="file-info-text">Max file size - 5MB</span>
              </div>
            </div>
          </div>

          <!-- Image Settings -->
          <div class="image-settings">
            <label class="form-label">How should the image look?</label>
            <select 
              class="form-select" 
              [value]="getPackageData(pkg.id)?.imageFit || 'fill'"
              (change)="onPackageImageFitChange(pkg.id, $any($event.target).value)">
              <option value="fill">Fill</option>
              <option value="cover">Cover</option>
              <option value="contain">Contain</option>
              <option value="fit">Fit</option>
            </select>
          </div>

          <!-- Button Text Input -->
          <div class="form-group">
            <label class="form-label">Add the button text here*</label>
            <input 
              type="text" 
              class="form-input"
              [value]="getPackageData(pkg.id)?.buttonText || 'Buy Now'"
              (input)="onPackageButtonTextChange(pkg.id, $any($event.target).value)"
              placeholder="Buy Now">
          </div>
        </div>
      </div>
    </div>

    <!-- Information Box -->
    <div class="info-box">
      <div class="info-box-icon">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M8 0C3.582 0 0 3.582 0 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zm0 12c-.552 0-1-.448-1-1s.448-1 1-1 1 .448 1 1-.448 1-1 1zm1-4H7V4h2v4z" fill="#6B7280"/>
        </svg>
      </div>
      <div class="info-box-content">
        <h4 class="info-box-title">How It Works</h4>
        <p class="info-box-text">All package details are directly taken from the 'Packages' section. Any edits must be made there.</p>
      </div>
    </div>

    <!-- Background Section -->
    <div class="accordion-section" [class.expanded]="isSectionExpanded('background')" (click)="toggleSection('background')">
      <div class="accordion-header">
        <h4 class="section-title">Background</h4>
        <button class="collapse-btn" [class.expanded]="isSectionExpanded('background')" type="button">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M4 6L8 10L12 6" stroke="#15172E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" vector-effect="non-scaling-stroke"/>
          </svg>
        </button>
      </div>
      
      <div class="accordion-content" *ngIf="isSectionExpanded('background')" (click)="$event.stopPropagation()">
        <div class="content-divider"></div>
        <!-- Color Swatches -->
        <div class="color-palette">
          <div class="color-list">
            <!-- Purple Color -->
            <div class="color-item" [class.selected]="data.backgroundColor === '#5E19A1'" (click)="onBackgroundColorChange('#5E19A1')">
              <div class="color-swatch" style="background-color: #5E19A1;"></div>
              <span class="color-code">#5E19A1</span>
              <div class="checkmark" *ngIf="data.backgroundColor === '#5E19A1'">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M10 3L4.5 8.5L2 6" stroke="#079271" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
            
            <!-- Orange Color -->
            <div class="color-item" [class.selected]="data.backgroundColor === '#FF9736'" (click)="onBackgroundColorChange('#FF9736')">
              <div class="color-swatch" style="background-color: #FF9736;"></div>
              <span class="color-code">#FF9736</span>
              <div class="checkmark" *ngIf="data.backgroundColor === '#FF9736'">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M10 3L4.5 8.5L2 6" stroke="#079271" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
            
            <!-- Green Color -->
            <div class="color-item" [class.selected]="data.backgroundColor === '#079271'" (click)="onBackgroundColorChange('#079271')">
              <div class="color-swatch" style="background-color: #079271;"></div>
              <span class="color-code">#079271</span>
              <div class="checkmark" *ngIf="data.backgroundColor === '#079271'">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M10 3L4.5 8.5L2 6" stroke="#079271" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
            
            <!-- Blue Color -->
            <div class="color-item" [class.selected]="data.backgroundColor === '#1B5BFF'" (click)="onBackgroundColorChange('#1B5BFF')">
              <div class="color-swatch" style="background-color: #1B5BFF;"></div>
              <span class="color-code">#1B5BFF</span>
              <div class="checkmark" *ngIf="data.backgroundColor === '#1B5BFF'">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M10 3L4.5 8.5L2 6" stroke="#079271" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
          </div>
          
          <!-- Divider -->
          <div class="color-divider"></div>
          
          <!-- Add Color Button -->
          <div class="add-color-section">
            <div class="color-item add-color" (click)="onAddColor()">
              <div class="color-swatch add-color-swatch">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M6 1V11M1 6H11" stroke="#15172E" stroke-width="1.5" stroke-linecap="round"/>
                </svg>
              </div>
              <span class="color-code">Add Color</span>
            </div>
          </div>

          <!-- Custom Colors (dynamically added) -->
          <div class="color-item" 
               *ngFor="let customColor of customColors; trackBy: trackByIndex" 
               [class.selected]="data.backgroundColor === customColor" 
               (click)="openColorPicker(customColor)">
            <div class="color-swatch" [style.background-color]="customColor"></div>
            <span class="color-code">{{ customColor }}</span>
            <div class="checkmark" *ngIf="data.backgroundColor === customColor">
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path d="M10 3L4.5 8.5L2 6" stroke="#079271" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>

  <!-- Color Picker Modal -->
  <div class="color-picker-overlay" *ngIf="isColorPickerOpen" (click)="closeColorPicker()">
    <div class="color-picker-modal" (click)="$event.stopPropagation()">
      <div class="color-picker-header">
        <h3 class="color-picker-title">Color picker</h3>
        <button class="color-picker-close" (click)="closeColorPicker()">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M1 1L11 11M11 1L1 11" stroke="#15172E" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </button>
      </div>
      <div class="color-picker-content">
        <chrome-picker 
          [(color)]="currentPickerColor"
          (colorChange)="onColorPickerChange()">
        </chrome-picker>
      </div>
    </div>
  </div>

  </div>

  <!-- Layout Tab -->
  <div class="panel-content" *ngIf="activeTab === 'layout'">
    <div class="empty-state">
      <p>Layout options coming soon...</p>
    </div>
  </div>
</div>
